// Socket message types (simplified for login use case)
export enum SocketMessageType {
  SESSION_ACCEPTED = 'SESSION_ACCEPTED',
  SESSION_ENDED = 'SESSION_ENDED',
  AUTHORIZATION_TOKEN = 'AUTHORIZATION_TOKEN',
  ACCESS_TOKEN_RECEIVED = 'ACCESS_TOKEN_RECEIVED',
}

// Authorization data interface
export interface AuthorizationData {
  accessToken: string;
  refreshToken: string;
  sessionId: string;
  userId?: string;
  expiresAt?: string | number;
  permissions?: string[];
  status?: 'pending' | 'authenticated' | 'expired' | (string & NonNullable<unknown>);
}

// Raw socket message structure (simplified for login use case)
export interface RawSocketMessage {
  type?: string;
  sessionId?: string;
  userId?: string;
  // Authorization specific fields
  accessToken?: string;
  refreshToken?: string;
  status?: 'pending' | 'authenticated' | 'expired' | (string & NonNullable<unknown>);
  authorization?: AuthorizationData;
  data?: AuthorizationData;
  message?: {
    sessionId?: string;
    userId?: string;
    accessToken?: string;
    authorization?: AuthorizationData;
  };
}

export interface SocketAuthorizeTokenPayload {
  accessToken: string;
  refreshToken: string;
  type: string;
}
